import { ModalContentType, SetStateType } from "types/generic";

type MakeGisLayerMasterWidgetFunctionsParams = {
    modalContent: ModalContentType;
    setModalContent: SetStateType<ModalContentType>;
    translate: (id: string) => string;
};

export const makeGisLayerMasterWidgetFunctions = ({
    modalContent,
    setModalContent,
    translate,
}: MakeGisLayerMasterWidgetFunctionsParams) => {
    const closeModal = () => {
        setModalContent(null);
    };

    const openCreateLayerModal = () => {
        setModalContent("create");
    };

    const openDeleteLayerModal = () => {
        setModalContent("delete");
    };

    const defineModalTitle = () => {
        return translate(
            modalContent === "create"
                ? "app.gis.create_new_layer"
                : "app.Components.warning.delete"
        );
    };

    return {
        closeModal,
        openCreateLayerModal,
        openDeleteLayerModal,
        defineModalTitle,
    };
};
